export default "__VITE_ASSET__DnxOnKKI__"